import { Box, Flex, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import UTMLink from "@components/UTMLink";
import { RESTAKE_SIDEBAR_GAIN } from "@constants/analytics";
import useVaultOverview from "@hooks/useVaultOverview";
import useYieldVaultData from "@hooks/useYieldVaultData";
import React from "react";
import { trackEvent } from "utils";

type TGainOpportunitiesCard = {
  id: string;
  title: string;
  logo: string;
  apy: string;
  tvl: string;
  link: string;
  divider?: boolean;
};

const GainOpportunities = () => {
  const { formattedApy, formattedTvl } = useVaultOverview();
  const { formattedApy: yieldApy, formattedTvl: yieldTvl } =
    useYieldVaultData();

  return (
    <Box bg="#E4F8F8" fontSize={12} borderRadius={16}>
      <Text fontWeight={600} fontSize={14} color="#3F6870" px="6" pt="6" mb="2">
        Gain opportunities
      </Text>
      <Flex
        bgColor={"#EBF9F9"}
        borderBottomRadius={"12px"}
        direction={"column"}
      >
        <GainOpportunitiesCard
          id="airdrop"
          title="Airdrop Gain"
          logo="/assets/ageth.svg"
          link="/gain/airdrop-gain/"
          apy={formattedApy}
          tvl={formattedTvl}
          divider
        />
        <GainOpportunitiesCard
          id="yield"
          title="High Gain"
          logo="/assets/vaults/hgeth.svg"
          link="/gain/growth-vault/"
          apy={yieldApy}
          tvl={yieldTvl}
        />
      </Flex>
    </Box>
  );
};

const GainOpportunitiesCard = ({
  id,
  title,
  logo,
  apy,
  tvl,
  link,
  divider = false,
}: TGainOpportunitiesCard) => {
  const extraProps = divider
    ? { borderBottom: "1px solid #B6DFDF", pb: "16px" }
    : { pt: "20px" };
  return (
    <UTMLink
      href={link}
      key={id}
      onClick={() => trackEvent(RESTAKE_SIDEBAR_GAIN, { vault_name: title })}
    >
      <Flex
        py="20px"
        pl="16px"
        pr="6px"
        justifyContent={"space-between"}
        alignItems={"center"}
        {...extraProps}
      >
        <Flex justifyContent={"space-between"} gap="8px">
          <BaseImage src={logo} width={36} height={36} alt={""} />
          <Flex gap="4px" direction={"column"}>
            <Text fontSize="14px" lineHeight="20px" fontWeight={500}>
              {title}
            </Text>
            <Flex>
              <Stats label={"APY"} value={apy} />
              <Stats label={"TVL"} value={tvl} />
            </Flex>
          </Flex>
        </Flex>
        <Box justifySelf="end" pr="8px">
          <Text fontSize={"20px"}>{">"}</Text>
        </Box>
      </Flex>
    </UTMLink>
  );
};

export default GainOpportunities;

const Stats = ({ label, value }: { label: string; value: string }) => {
  return (
    <Flex gap="3px">
      <Text
        fontSize={{ base: "12px", md: "12px" }}
        lineHeight={{ base: "20px", md: "20px" }}
        fontWeight={400}
      >
        {label}:
      </Text>
      <Text
        minWidth={"50px"}
        fontSize={{ base: "12px", md: "12px" }}
        lineHeight={{ base: "20px", md: "20px" }}
        fontWeight={500}
      >
        {value}
      </Text>
    </Flex>
  );
};
